export default __webpack_public_path__ + "static/media/analytics-image.66ec9d1f.png";